import React from 'react';
import { formatCompact, formatCompactTonnes } from '../utils/formatNumber';

const StatsGrid = ({ data, exportMetrics, containerData }) => {
  return (
    <div className="grid grid-cols-4 gap-4 mb-6">
      {/* Total Exports Till Date */}
      <div className="bg-gradient-to-br from-cyan-500 to-teal-600 rounded-xl p-6">
       <div className="flex items-center gap-2 mb-2">
  <span className="text-sm text-white/80">TOTAL EXPORTS TILL DATE</span>
  <span className="px-4 py-4 bg-blue-600 rounded text-3xl font-bold">{data.mineral}</span>
</div>
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-bold">{formatCompact(exportMetrics.totalExport.value, { currency: 'USD' })}</span>
          <span className="text-xl">|</span>
          <span className="text-3xl font-semibold">{formatCompactTonnes(exportMetrics.totalExport.weight)}</span>
          <span className="px-2 py-1 bg-gray-900 rounded text-sm">tonnes</span>
        </div>
      </div>





      

      {/* Total Export This Montbecouse when post it rutnr the data may be is because in not picking the countryh */}
      <div className="bg-[#252836] rounded-xl p-6 border border-gray-700">
        <div className="text-sm text-gray-400 mb-2">TOTAL EXPORT THIS MONTH</div>
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-bold">{formatCompact(exportMetrics.thisMonthExport.value, { currency: 'USD' })}</span>
          <span className="text-gray-400">{formatCompactTonnes(exportMetrics.thisMonthExport.weight)} tonnes</span>
        </div>
      </div>

      {/* Total Export YTD */}
      <div className="bg-[#252836] rounded-xl p-6 border border-gray-700">
        <div className="text-sm text-gray-400 mb-2">TOTAL EXPORT YTD</div>
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-bold">{formatCompact(exportMetrics.ytdExport.value, { currency: 'USD' })}</span>
          <span className="text-gray-400">{formatCompactTonnes(exportMetrics.ytdExport.weight)} tonnes</span>
        </div>
      </div>

      {/* Current Stock */}
      <div className="bg-[#252836] rounded-xl p-6 border border-gray-700">
        <div className="text-sm text-gray-400 mb-2">CURRENT STOCK</div>
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-bold">{formatCompact((containerData?.total_value || 0), { currency: 'USD' })}</span>
          <span className="text-gray-400">{formatCompactTonnes((containerData?.total_weight || 0))} tonnes</span>
        </div>
      </div>
    </div>
  );
};

export default StatsGrid;